const statusColors = {
  draft: 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300',
  developing: 'bg-blue-100 text-blue-700 dark:bg-blue-900/50 dark:text-blue-400',
  ready: 'bg-green-100 text-green-700 dark:bg-green-900/50 dark:text-green-400',
  published: 'bg-purple-100 text-purple-700 dark:bg-purple-900/50 dark:text-purple-400',
  archived: 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/50 dark:text-yellow-400',
};

export default function IdeaStatusBadge({ status }) {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
        statusColors[status] || 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300'
      }`}
    >
      {status}
    </span>
  );
}
